export const AccordionItemIds = {
    accounts: "accounts",
    personalAssets: "personalAssets",
    lifeInsurances: "lifeInsurances",
    personalLiabilities: "personalLiabilities",
    futureInflows: "futureInflows"
}